/* ブロック */
import React from 'react';
import { Card } from 'react-bootstrap';

interface Props {
  label: string;
  content: JSX.Element;
}

const Block: React.FC<Props> = ({ label, content }) => {
  return (
    <>
      <Card className="block mx-auto col-xs-11 col-sm-11 col-md-8 col-11 px-0">
        <Card.Header className="block-header label">{label}</Card.Header>
        <Card.Body>
          <div className="content">{content}</div>
        </Card.Body>
      </Card>
    </>
  );
};

export default Block;
